import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as _function from '../function'

// NOTE: this is generally used for VAC and UN
export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: _function.RESOURCE.payload.dimension.partialId,
      partialId: _function.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'Space that is assigned to this function cannot be assigned to another at the same time',
    isOptional: false,
    name: 'Is Exclusive?',
    partialId: PartialId.Standard.create('is_exclusive'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
